import { render, staticRenderFns } from "./PhenologicalStages.vue?vue&type=template&id=0fe44982&scoped=true&lang=html&"
import script from "./PhenologicalStages.vue?vue&type=script&lang=js&"
export * from "./PhenologicalStages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe44982",
  null
  
)

export default component.exports